(function() {
  'use strict';

  angular.module('cfn').factory('frontendFilterService', frontendFilterService);

  frontendFilterService.$inject = ['arrayItemKeyFilterService'];

  function frontendFilterService(arrayItemKeyFilterService) {
    var FILTER_TYPES = {
      CALLBACK: 'callback',
      ARRAY_ITEM_KEY: 'array_item_key'
    };

    /**
     * filter method plugins
     * @type {Object}
     */
    var filterMethods = {};
    filterMethods[FILTER_TYPES.ARRAY_ITEM_KEY] = arrayItemKeyFilterService;
    filterMethods[FILTER_TYPES.CALLBACK] = function(
      dataItem,
      filterValue,
      filterConfig
    ) {
      return filterConfig.callback(dataItem, filterValue, filterConfig);
    };

    /**
     * create a filter service instance
     *
     * config example:
     * {
         activity: {
           type: frontendFilterService.FILTER_TYPES.CALLBACK,
           callback: function(dataItem, filterValue, filterConfig) {
             return dataItem.activity.name === filterValue;
           }
         },
         field: {
           type: frontendFilterService.FILTER_TYPES.ARRAY_ITEM_KEY,
           dataItemProperty: 'fields',
           dataItemKey: 'id'
         },
     * }
     *
     * @param  {object} config
     * @return {object}
     */
    function create(config) {
      var service = {
        filter: filter
      };
      return service;

      /**
       * filter function
       * @param  {array} data
       * @param  {object} filterValues
       * @return {array} filteredData
       */
      function filter(data, filterValues) {
        if (_.isEmpty(filterValues)) {
          return data;
        }
        return _.filter(data, function(dataItem) {
          var filterConfig;
          for (var fieldName in filterValues) {
            filterConfig = config[fieldName];
            if (!filterConfig) {
              console.error('no config for field: ' + fieldName);
              continue;
            }
            if (
              !filterMatches(dataItem, filterConfig, filterValues[fieldName])
            ) {
              return false;
            }
          }
          return true;
        });
      }

      /**
       * executes the defined filter method
       * @param  {object} dataItem
       * @param  {object} filterConfig
       * @param  {mixed} filterValue
       * @return {Boolean}
       */
      function filterMatches(dataItem, filterConfig, filterValue) {
        try {
          return filterMethods[filterConfig.filterMethod].call(
            null,
            dataItem,
            filterValue,
            filterConfig
          );
        } catch (e) {
          console.error('error', e);
          return true;
        }
      }
    }

    create.FILTER_TYPES = FILTER_TYPES;

    return create;
  }
})();
